// Fachregeln der Akquise an einer Stelle (Bestand Planung Recherche/18 Teil B und C; neuratek/akquise/ablauf.md).
// Server leitet damit die gespeicherten Felder Stufe, Schritt und Kontaktweg ab; die Oberfläche zeigt dieselben Texte.

export const BUNDESLAENDER = ['Baden-Württemberg', 'Bayern', 'Berlin', 'Brandenburg', 'Bremen', 'Hamburg', 'Hessen', 'Mecklenburg-Vorpommern', 'Niedersachsen', 'Nordrhein-Westfalen', 'Rheinland-Pfalz', 'Saarland', 'Sachsen', 'Sachsen-Anhalt', 'Schleswig-Holstein', 'Thüringen'] as const;
export type Bundesland = (typeof BUNDESLAENDER)[number];
/** Liste für Firmen, deren Bundesland weder eingetragen noch aus der PLZ bestimmbar ist (Stufe 3 holt es nach) */
export const OHNE_LAND = 'ohne Bundesland';

// EN-094: 18 feste Überkategorien
export const UEBERKATEGORIEN = ['Reinigung', 'Gebäudedienste', 'Ausbauhandwerk', 'Dach und Fassade', 'Haustechnik', 'Bau', 'Planung und Beratung', 'Garten und Landschaft', 'Entsorgung', 'Transport und Logistik', 'Immobilien', 'Handel', 'Kfz', 'Industrie und Produktion', 'Gesundheit und Pflege', 'Unternehmensdienste', 'Öffentlich und Soziales', 'Sonstiges'] as const;

// EN-095: Startliste der Kategorien je Überkategorie
export const KATEGORIEN_START: Record<string, string[]> = {
  Reinigung: ['Gebäudereinigung', 'Fensterreinigung', 'Textilreinigung', 'Teppich- und Polsterreinigung', 'Fassaden- und Strahlreinigung', 'Rohr- und Kanalreinigung', 'Fahrzeugreinigung'],
  Gebäudedienste: ['Hausmeisterservice', 'Winterdienst', 'Schädlingsbekämpfung', 'Sicherheitsdienst', 'Entrümpelung'],
  Ausbauhandwerk: ['Maler', 'Fliesenleger', 'Trockenbau', 'Bodenleger', 'Raumausstatter', 'Stuckateur', 'Tischler', 'Fenster und Türen'],
  'Dach und Fassade': ['Dachdecker', 'Zimmerer', 'Schornsteinfeger', 'Metallbau'],
  Haustechnik: ['Elektroinstallation', 'Sanitär und Heizung', 'Klima und Lüftung', 'Solartechnik', 'Aufzüge'],
  Bau: ['Bauunternehmen', 'Abbruch', 'Sanierung', 'Tiefbau', 'Brunnenbau', 'Pool- und Schwimmbadbau'],
  'Planung und Beratung': ['Architektur', 'Ingenieurbüro', 'Vermessung', 'Energieberatung'],
  'Garten und Landschaft': ['Garten- und Landschaftsbau', 'Baumarbeiten'],
  Entsorgung: ['Abfallentsorgung', 'Containerdienst', 'Schrotthandel'],
  'Transport und Logistik': ['Spedition und Umzug', 'Kurier und Paketdienst', 'Personenbeförderung', 'Logistik'],
  Immobilien: ['Hausverwaltung', 'Immobilienmakler', 'Wohnungsunternehmen', 'Projektentwicklung'],
  Handel: ['Großhandel', 'Fachhandel', 'Einzelhandel'],
  Kfz: ['Autowerkstatt', 'Autohandel', 'Kfz-Dienste'],
  'Industrie und Produktion': ['Maschinenbau', 'Metallverarbeitung', 'Kunststoffverarbeitung', 'Elektrotechnik', 'Lebensmittelherstellung', 'Druckerei'],
  'Gesundheit und Pflege': ['Pflegedienst', 'Pflegeheim', 'Arztpraxis', 'Heilpraktiker', 'Krankentransport'],
  Unternehmensdienste: ['Marketing und Werbung', 'Personaldienstleistung', 'IT-Dienstleistung', 'Versicherung', 'Unternehmensberatung'],
  'Öffentlich und Soziales': ['Verwaltung', 'Bildung und Betreuung', 'Soziale Einrichtung', 'Verein'],
  Sonstiges: ['Gastronomie', 'Friseur', 'Schneiderei', 'Schlüsseldienst', 'Veranstaltungen']
};

// Dienste mit Seite zum Aufladen; bezahlt wird dort von Leon (Korrekturrunde 1, Freigabestufe 3)
export const DIENSTE = ['Scraping-Dienst', 'Mail-Prüfdienst', 'KI-Dienst'] as const;
export const AUFLADEN: Record<string, string> = {
  'Scraping-Dienst': 'https://console.apify.com/billing', 'Mail-Prüfdienst': 'https://app.usebouncer.com/',
  'KI-Dienst': 'https://console.anthropic.com/settings/billing'
};

// Fünf Stufen der Anreicherung (Prototyp STUFEN), Marker je Stufe aus dem Bestand (Abschnitt 1.3)
export const STUFEN = ['Kategorie und Förderfähigkeit', 'Impressum', 'Förderquote', 'Persönliche Mail', 'Website-Bewertung'] as const;

// AK-030: Kontaktwege in fester Reihenfolge
export const WEGE = ['Mail persönlich', 'Mail allgemein mit AP', 'Mail allgemein', 'Telefon persönlich', 'Telefon allgemein'] as const;
export type Weg = (typeof WEGE)[number];

// Prüfarten; die ersten drei halten die Ansprache an (Bestand EN 1.4)
export const PRUEFARTEN: [string, boolean][] = [['Website-Typ', true], ['Impressum', true], ['Impressumsdaten', true], ['Kategorie und Förderung', false], ['Website-Bewertung', false]];

// Website-Bewertung (Leon 2026-11-03, Jarvis neuratek/akquise/website-bewertung.md): eine Frage, lohnt sich ein Website-Angebot?
export const WEBSITE_URTEILE = ['anbieten', 'nicht anbieten', 'unsicher'] as const;
export type WebsiteUrteil = (typeof WEBSITE_URTEILE)[number];
/** Fünf Punkte zum Hinsehen, in fester Reihenfolge (Schlüssel der Antwort der Routine und Beschriftung) */
export const WEBSITE_PUNKTE = [['eindruck', 'Erster Eindruck'], ['handy', 'Handy'], ['eigenstaendig', 'Eigenständig oder Vorlage'], ['klarheit', 'Klarheit'], ['sorgfalt', 'Sorgfalt']] as const;
export const haeltAn = (art: string | null) => PRUEFARTEN.some(([a, h]) => a === art && h);

// EN-013
export const WEBTYPEN = ['eigene Website', 'keine Website vorhanden', 'Portal', 'kein Unternehmen', 'Prüfen - Verdacht auf Portal', 'Prüfen - unklar'] as const;

// AK-028: Akquise-Status je Angebot
export const AK_STATUS = ['wartet', 'Mail raus', 'Anrufliste', 'Rückmeldung offen', 'Nachfassen', 'in Kontakt', 'Termin', 'Kunde', 'kein Interesse', 'keine Rückmeldung', 'kein Kontaktweg', 'gesperrt'] as const;
export const ANGEBOTE = ['Website', 'KI'] as const;
export type Angebot = (typeof ANGEBOTE)[number];
export const ENTSCHEIDUNGEN = ['ja – Anruf', 'ja – Mail', 'später', 'nein'] as const;

// EN-153 und Apollo
export const MAILSTATUS = ['Übernommen – ungeprüft', 'Selbst verifiziert', 'Apollo verifiziert', 'Nicht gefunden', 'Technisch nicht ermittelbar', 'Kein Ansprechpartner', 'Vor- oder Nachname fehlt', 'Website nicht erreichbar'] as const;

// Stufen der Liste (Prototyp STAGE, ORDER)
export const STUFE_INFO = {
  anr: { label: 'In Anreicherung', ton: 'accent' }, pruef: { label: 'Prüfen', ton: 'warn' }, frei: { label: 'Fertig und frei', ton: 'neutral' },
  kamp: { label: 'In Kampagne', ton: 'accent' }, crm: { label: 'Ins CRM übertragen', ton: 'ok' }, ende: { label: 'Erledigt', ton: 'neutral' }
} as const;
export type Stufe = keyof typeof STUFE_INFO;
export const STUFEN_REIHE: Stufe[] = ['anr', 'pruef', 'frei', 'kamp', 'crm', 'ende'];

export const ENDE_STATUS = ['kein Interesse', 'keine Rückmeldung', 'kein Kontaktweg'];
export const STOPP_STATUS = ['gesperrt', 'nicht mehr aktiv', 'nicht ansprechen', 'schon im CRM'];

/** Die Felder einer Firma, aus denen Stufe, Schritt und Kontaktweg folgen. */
export interface FirmaKern {
  website_typ: string | null;
  ansprechpartner: string | null;
  email_persoenlich: string | null;
  email_allgemein: string | null;
  telefon_allgemein: string | null;
  telefon_direkt: string | null;
  pruefung_offen: string | null;
  status: string | null;
  website_bewerten: boolean;
  s1_marker: string | null; s2_marker: string | null; s3_marker: string | null; s4_marker: string | null; s5_marker: string | null;
  angebote: { angebot: string; status: string | null }[];
}

const ohneWebsite = (f: FirmaKern) => f.website_typ === 'keine Website vorhanden';
const portal = (f: FirmaKern) => f.website_typ === 'Portal' || f.s2_marker === 'Portal - keine weiteren Stufen';

/** Marker einer Stufe, wie ihn Liste und Detailfenster zeigen (Prototyp marker()). Leer = noch nicht gelaufen. */
export function markerAnzeige(f: FirmaKern, i: number): string {
  const m = [f.s1_marker, f.s2_marker, f.s3_marker, f.s4_marker, f.s5_marker][i] ?? '';
  if (ohneWebsite(f) && (i === 1 || i === 3)) return 'nicht nötig ohne Website';
  if (portal(f) && i > 2) return 'nicht nötig (Portal)';
  if (i === 4 && (f.s2_marker ?? '').toLowerCase().includes('nicht erreichbar')) return 'nicht nötig (Website nicht erreichbar)';
  if (i === 4 && !f.website_bewerten) return 'nicht beauftragt';
  return m;
}

/** Erste Stufe (1–5), die noch läuft; 6 = Anreicherung fertig. */
export function schritt(f: FirmaKern): number {
  for (let i = 0; i < 5; i++) if (!markerAnzeige(f, i)) return i + 1;
  return 6;
}

/** Kontaktwege, die eine Firma hat, in fester Reihenfolge (AK-030). */
export function vorhandeneWege(f: FirmaKern): boolean[] {
  const tel = Boolean(f.telefon_allgemein || f.telefon_direkt), ap = Boolean(f.ansprechpartner);
  return [Boolean(f.email_persoenlich), Boolean(f.email_allgemein) && ap, Boolean(f.email_allgemein), tel && ap, tel];
}

export function wegVon(f: FirmaKern): Weg | null {
  if (schritt(f) <= 2) return null;
  const i = vorhandeneWege(f).findIndex(Boolean);
  return i < 0 ? null : WEGE[i];
}

export function endeGrund(f: FirmaKern): string | null {
  if (f.status && STOPP_STATUS.includes(f.status)) return f.status;
  if (f.s2_marker === 'Portal - keine weiteren Stufen' || f.s2_marker === 'Kein Unternehmen - keine weiteren Stufen') return f.s2_marker;
  if (f.s1_marker === 'kein Unternehmen') return 'kein Unternehmen';
  const mit = f.angebote.filter(a => a.status);
  if (mit.length && mit.every(a => ENDE_STATUS.includes(a.status!))) return mit[0].status;
  return null;
}

/** Stufe der Liste; Vorrang: übertragen > erledigt > Prüfung offen > in Kampagne > Anreicherung > fertig und frei. */
export function stufeVon(f: FirmaKern): Stufe {
  if (f.status === 'in Vertrieb CRM überführt') return 'crm';
  if (endeGrund(f)) return 'ende';
  if (f.pruefung_offen) return 'pruef';
  if (f.angebote.some(a => a.status && !ENDE_STATUS.includes(a.status))) return 'kamp';
  return schritt(f) < 6 ? 'anr' : 'frei';
}

/** Firmen-ID wie im Bestand: F-000123 */
export const firmenId = (id: number) => 'F-' + String(id).padStart(6, '0');
export const idAusFirmenId = (fid: string): number | null => { const m = /^F-(\d{6,})$/.exec(fid); return m ? Number(m[1]) : null; };

/** Telefon zum Vergleichen: nur Ziffern, Landesvorwahl 49 wie 0, die letzten 8 Ziffern; null bei weniger als 8 Ziffern */
const telKern = (t: string | null | undefined) => { const z = (t ?? '').replace(/\D/g, '').replace(/^(00)?49/, '0'); return z.length >= 8 ? z.slice(-8) : null; };

/** Straße zum Vergleichen: klein, ohne Akzente, „Straße/Str./Strasse“ gleich, ohne Leer- und Satzzeichen („Hauptstr. 5a“ = „Hauptstraße 5 a“) */
const strKern = (s: string | null | undefined) => {
  const z = (s ?? '').toLowerCase().normalize('NFD').replace(/\p{M}/gu, '').replace(/ß/g, 'ss').replace(/str(asse|\.|\b)/g, 'str').replace(/[^a-z0-9]/g, '');
  return /\d/.test(z) && z.length >= 4 ? z : null;
};

type Anschrift = { plz: string | null; telefon: string | null; strasse?: string | null };

/**
 * Website-Typ (Leon 2026-11-04): Gehört die Website zur Firma? „passt“: die Telefonnummer stimmt, oder Straße und PLZ stimmen;
 * dann ist nur der Name falsch. Die PLZ allein reicht nicht. „passt nicht“: PLZ und Telefon verglichen und beide anders, die
 * Website gehört einer anderen Firma. Sonst „unklar“ (Leon entscheidet).
 */
export function abgleich(datensatz: Anschrift, impressum: Anschrift | null): 'passt' | 'passt nicht' | 'unklar' {
  if (!impressum) return 'unklar';
  const plz = datensatz.plz && impressum.plz ? datensatz.plz.trim() === impressum.plz.trim() : null;
  const a = telKern(datensatz.telefon), b = telKern(impressum.telefon);
  const tel = a && b ? a === b : null;
  const sa = strKern(datensatz.strasse), sb = strKern(impressum.strasse);
  if (tel || (plz && sa && sb && sa === sb)) return 'passt';
  return plz === false && tel === false ? 'passt nicht' : 'unklar';
}

export const NICHT_ANSPRECHEN = 'nicht ansprechen (zu klein oder ungeeignet)';

// Prüfarten mit Frage, Entscheidungen der alten Prüfblätter (EN-205 bis EN-219) und Feldern (Prototyp PARTEN).
// Abweichung vom Prototyp: „Website gehört einer anderen Firma“ sucht nicht automatisch (Leon 2026-10-20, keine automatische Website-Suche).
export const PRUEF_ARTEN: Record<string, { bremst: boolean; frage: string; optionen: [string, string][]; felder: [string, string][] }> = {
  'Website-Typ': { bremst: true, frage: 'Ist das die eigene Website der Firma?', optionen: [
    ['Portal bestätigt', 'Domain wird als Portal gelernt; Firmen mit derselben Domain werden sofort als Portal erkannt.'],
    ['kein Portal – eigene Website', 'Impressum wird neu gelesen, die Anreicherung läuft weiter.'],
    ['Website gehört einer anderen Firma', 'Website wird entfernt; ohne neu eingetragene Website geht es nur per Telefon weiter.'],
    ['Website nicht erreichbar', 'Förderquote und Kontaktweg laufen ohne Website weiter.'],
    ['kein Unternehmen bestätigt', 'Firma wird nicht angesprochen.'],
    ['doch ein Unternehmen', 'Website-Typ wird neu bestimmt.']],
    felder: [['Richtige Website', 'nur wenn du eine andere, echte Seite gefunden hast'], ['Richtiger Firmenname', 'nur bei erkennbar falschem Namen'], ['Richtige Branche', 'nur wenn sie fehlt oder nicht passt']] },
  Impressum: { bremst: true, frage: 'Wo steht das Impressum?', optionen: [
    ['Impressum-URL eingetragen', 'Impressum wird von dieser Adresse gelesen; der Pfad wird für andere Firmen gelernt.'],
    ['kein Impressum vorhanden', 'Weiter ohne Impressumsdaten (endgültig).'],
    ['Website nicht erreichbar', 'Förderquote und Kontaktweg laufen ohne Website weiter.']],
    felder: [['Impressum-URL', 'Adresse vorher einmal aufrufen']] },
  Impressumsdaten: { bremst: true, frage: 'Was fehlt aus dem Impressum?', optionen: [
    ['ergänzt', 'Gespeichert; die persönliche Mail wird gesucht.'],
    ['nicht auffindbar', 'Weiter ohne diese Angaben.'],
    ['Portal', 'Website-Typ wird Portal; die Domain wird gelernt, keine weiteren Stufen.']],
    felder: [['Ansprechpartner', 'vertretungsberechtigte Person, nur Vor- und Nachname'], ['allg. Mail', 'die allgemeinste Adresse, nie erfinden'], ['PLZ', 'fünfstellig, Firmensitz']] },
  'Kategorie und Förderung': { bremst: false, frage: 'Welche Kategorie, ist die Firma förderfähig?', optionen: [
    ['Übernehmen', 'Gespeichert; von Hand gesetzte Werte überschreibt nichts mehr.'],
    [NICHT_ANSPRECHEN, 'Die Firma wird für beide Angebote nicht angesprochen (Ende, ohne Sperrliste).']],
    felder: [['Branche', 'kurz, Einzahl'], ['Kategorie', 'bestehende bevorzugen'], ['Förderfähig', 'ja, nein oder prüfen'], ['Förderquote', '80 % oder 50 %']] },
  // bremst nicht: nur das Website-Angebot wartet; deine Wahl wird ein Beispiel für die Website-Routine
  'Website-Bewertung': { bremst: false, frage: 'Lohnt sich ein Website-Angebot?', optionen: [
    ['anbieten', 'Die Firma bekommt das Website-Angebot; deine Wahl lernt die Bewertung als Beispiel.'],
    ['nicht anbieten', 'Kein Website-Angebot (andere Angebote bleiben); deine Wahl lernt die Bewertung als Beispiel.'],
    ['Website gehört einer anderen Firma', 'Website wird entfernt; die Firma bekommt das Angebot für eine erste eigene Website.'],
    ['Website nicht erreichbar', 'Die Firma bekommt die Mail „Website nicht erreichbar“, wenn die Seite beim Versand noch nicht antwortet.']],
    felder: [] }
};
